import { ButtonType, ButtonWidget, Tooltip, TooltipPosition } from '@tableau/widgets';
import React from 'react';

import { Messages } from '../../../codegen/Localize';
import { imgPath } from '../../../common/utilities/ImgUrl';
import { WelcomeChannelTestIds } from '../../../home/components/WelcomeChannel';
import { WelcomeChannelStyles } from '../../../home/styles/WelcomeChannelStyles';

export interface WelcomeChannelCloseButtonProps {
  handleClick: () => void;
  tooltipText: string;
  disabled: boolean;
  footerOnly?: boolean; // If only the server footer is shown and not the default banner
}

export class WelcomeChannelCloseButton extends React.PureComponent<WelcomeChannelCloseButtonProps> {

  private getTooltipContent = (): Promise<JSX.Element> => {
    return new Promise(resolve => {
      // Adds a delay to the Tooltip showing. Example taken from the shared-widgets docs
      window.setTimeout(() => { resolve(<span>{this.props.tooltipText}</span>); }, 350);
    });
  }

  private getCloseButtonContent = (): JSX.Element => {
    return (
      <div style={WelcomeChannelStyles.closeButton}>
        <div style={{display: 'inline-flex'}}>
          <img
            src={imgPath('dialogs_close_white_active.svg')}
            draggable={false}
            alt={Messages.home_welcomeChannel_dismiss_alttext()}
            style={{width: '100%', height: '100%'}}
          />
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className={this.props.footerOnly ? WelcomeChannelStyles.closeButtonFooterContainer : WelcomeChannelStyles.closeButtonContainer}>
        <Tooltip
          position={TooltipPosition.Right}
          testId={WelcomeChannelTestIds.closeButtonTooltip}
          getContent={this.getTooltipContent}
        >
          <ButtonWidget
            buttonType={ButtonType.IconOutline}
            handleClick={this.props.handleClick}
            testId={WelcomeChannelTestIds.closeButton}
            getContent={this.getCloseButtonContent}
            disabled={this.props.disabled}
          />
        </Tooltip>

      </div>
    );
  }
}
